import {getCurrentYear} from '../../utils/commons'
import BestCarGearPicksLogo from './logo'
import {bestCarGearPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestcargearpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Car Gear Picks',
  logo: <BestCarGearPicksLogo className="size-12 shrink-0 tablet:size-10" />,
  favicon: '/favicons/bestcargearpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-S5FHCMP08G',
    camelCaseUrl: 'BestCarGearPicks.com',
    title: (category: string, count: string) =>
      `Best ${count} ${category} to Buy in ${getCurrentYear()} | BestCarGearPicks.com – Reliable Reviews & Top Auto Gear Picks`,
    description: (category?: string, count?: string) =>
      `Find the best ${count} ${category} for ${getCurrentYear()} at BestCarGearPicks.com. Trusted reviews, side-by-side comparisons, and essential car gear tips to upgrade your ride.`,
    styles: bestCarGearPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
